import {Locales} from '@netx/core-next/locales/utils/Locales';

import {CART_CURRENT_EVENT} from './actions';

export const CART_CURRENT_ACTION_LABELS = Locales((i18n) => ({
	CATEGORIZE: i18n('i18n.organize'),
	CATEGORIZE_ADD: i18n('i18n.addToCategory'),
	CATEGORIZE_MOVE: i18n('i18n.moveToCategory'),
	CATEGORIZE_REMOVE: i18n('i18n.removeFromCategory'),
	CREATE_PDF: i18n('i18n.createPDF'),
	CREATE_PDF_SHARE_LINK: i18n('i18n.createLink'),
	CREATE_PDF_DOWNLOAD: i18n('i18n.download'),
	CREATE_TMS_OBJECT_PACKAGE: i18n('i18n.createObjectPackageInTMS'),
	DELETE: i18n('i18n.deleteCurrentCartAssets'),
	DOWNLOAD: i18n('i18n.download'),
	EDIT_ATTRIBUTES: i18n('i18n.editAttributes'),
	EXPORT_ATTRIBUTES: i18n('i18n.exportMetadata'),
	EXPORT_ATTRIBUTES_DOWNLOAD: i18n('i18n.download'),
	EXPORT_ATTRIBUTES_SHARE_LINK: i18n('i18n.createLink'),
	EMPTY: i18n('i18n.clearCart'),
	FIND_REPLACE: i18n('i18n.findReplace'),
	MANAGE_ARCHIVE: i18n('i18n.manageArchive'),
	MANAGE_ARCHIVE_ARCHIVE: i18n('i18n.archive'),
	MANAGE_ARCHIVE_UNARCHIVE: i18n('i18n.unarchive'),
	MANAGE_EXPIRATION: i18n('i18n.manageAssetExpiration'),
	MANAGE_EXPIRATION_SET: i18n('i18n.setExpiration'),
	MANAGE_EXPIRATION_UNSET: i18n('i18n.unexpireAssets'),
	MENU: i18n('i18n.share'),
	RELATIONSHIPS: i18n('i18n.relationships'),
	RELATIONSHIPS_LINK: i18n('i18n.link'),
	RELATIONSHIPS_DELINK: i18n('i18n.delink'),
	REPURPOSE: i18n('i18n.repurpose'),
	RESYNC: i18n('i18n.resync'),
	REVIEW: i18n('i18n.review'),
	SAVE: i18n('i18n.collect'),
	VISIBILITY: i18n('i18n.visibility'),
	VISIBILITY_HIDE: i18n('i18n.setToHidden'),
	VISIBILITY_SHOW: i18n('i18n.setToVisible'),
}));
